export const firstLogin = {
  completeYourInfo: 'Completá tus datos',
  email: 'E-mail',
  phone: 'Teléfono',
  address: 'Domicilio',
}



// WEBPACK FOOTER //
// ./src/sections/firstlogin/text.js